import { gql } from "graphql-request";

export const ADMIN_FILE_HISTORIES = gql`
  query AdminFileHistories($fileId: ID!) {
    adminFileHistories(fileId: $fileId) {
      _id
      title
      fileId
      workspaceId
      contentLength
      saveType
      createdAt
      updatedAt
    }
  }
`;

export const ADMIN_FILE_HISTORY_CONTENT = gql`
  query AdminFileHistoryContent($historyId: ID!) {
    adminFileHistoryContent(historyId: $historyId) {
      _id
      title
      content
      contentLength
      saveType
      createdAt
      updatedAt
    }
  }
`;
